import { comparisonData } from '@/mocks/categories';

export default function ComparisonSection() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Why Use Basetao Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            See how an organized spreadsheet approach compares to traditional product searching
          </p>
        </div>

        <div className="overflow-x-auto">
          <div className="min-w-[600px]">
            <div className="grid grid-cols-3 rounded-lg overflow-hidden border border-background-200/70">
              <div className="bg-background-200/70 px-5 py-4 text-sm font-semibold text-foreground-800">
                Feature
              </div>
              <div className="bg-background-200/70 px-5 py-4 text-sm font-semibold text-foreground-800 text-center">
                Traditional Search
              </div>
              <div className="bg-background-200/70 px-5 py-4 text-sm font-semibold text-primary-700 text-center">
                Basetao Spreadsheet
              </div>
              {comparisonData.flatMap((row, idx) => [
                <div
                  key={`feat-${idx}`}
                  className={`px-5 py-3.5 text-sm text-foreground-700 font-medium ${
                    idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100'
                  }`}
                >
                  {row.feature}
                </div>,
                <div
                  key={`trad-${idx}`}
                  className={`px-5 py-3.5 text-sm text-foreground-500 text-center ${
                    idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100'
                  }`}
                >
                  {row.traditional}
                </div>,
                <div
                  key={`base-${idx}`}
                  className={`px-5 py-3.5 text-sm text-primary-600 font-medium text-center ${
                    idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100'
                  }`}
                >
                  {row.basetao}
                </div>,
              ])}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}